import { getRegion } from '../i18n/regions';

export const getRedirectUrlWithRegion = (pageRoute: string) => {
  const region = getRegion();

  if (region) return `/${region.id}${pageRoute}`;

  return `${pageRoute}`;
};
